export default {
  FETCH_USER_ACTIVITY_REPORTS_REQUEST: 'FETCH_USER_ACTIVITY_REPORTS_REQUEST',
  FETCH_USER_ACTIVITY_REPORTS_SUCCESS: 'FETCH_USER_ACTIVITY_REPORTS_SUCCESS',
  FETCH_USER_ACTIVITY_REPORTS_FAILURE: 'FETCH_USER_ACTIVITY_REPORTS_FAILURE',

  DOWNLOAD_USER_ACTIVITY_REPORTS_REQUEST: 'DOWNLOAD_USER_ACTIVITY_REPORTS_REQUEST',
  DOWNLOAD_USER_ACTIVITY_REPORTS_SUCCESS: 'DOWNLOAD_USER_ACTIVITY_REPORTS_SUCCESS',
  DOWNLOAD_USER_ACTIVITY_REPORTS_FAILURE: 'DOWNLOAD_USER_ACTIVITY_REPORTS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/admin-reports/actions/action-types.js